module.exports = __webpack_public_path__ + "static/media/dress-code3.59ea9aa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dressCode/dress-code3.jpg
// module id = 704
// module chunks = 0